var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M13.6604 4.95117C14.1037 4.54023 14.3811 3.9529 14.3811 3.30078C14.3811 2.05814 13.3737 1.05078 12.1311 1.05078C10.8885 1.05078 9.8811 2.05814 9.8811 3.30078C9.8811 3.9529 10.1585 4.54023 10.6018 4.95117H5.6311C5.07882 4.95117 4.6311 5.39889 4.6311 5.95117V20.9727C4.6311 21.5249 5.07882 21.9727 5.6311 21.9727H18.6311C19.1834 21.9727 19.6311 21.5249 19.6311 20.9727V5.95117C19.6311 5.39889 19.1834 4.95117 18.6311 4.95117H13.6604ZM13.1811 3.30078C13.1811 3.88068 12.711 4.35078 12.1311 4.35078C11.5512 4.35078 11.0811 3.88068 11.0811 3.30078C11.0811 2.72088 11.5512 2.25078 12.1311 2.25078C12.711 2.25078 13.1811 2.72088 13.1811 3.30078ZM7.53113 12.3227C7.53113 11.9913 7.79976 11.7227 8.13113 11.7227H16.1311C16.4625 11.7227 16.7311 11.9913 16.7311 12.3227C16.7311 12.654 16.4625 12.9227 16.1311 12.9227H8.13113C7.79976 12.9227 7.53113 12.654 7.53113 12.3227ZM8.13113 8.70898C7.79976 8.70898 7.53113 8.97761 7.53113 9.30898C7.53113 9.64036 7.79976 9.90898 8.13113 9.90898H16.1311C16.4625 9.90898 16.7311 9.64036 16.7311 9.30898C16.7311 8.97761 16.4625 8.70898 16.1311 8.70898H8.13113ZM7.53113 15.3363C7.53113 15.005 7.79976 14.7363 8.13113 14.7363H16.1311C16.4625 14.7363 16.7311 15.005 16.7311 15.3363C16.7311 15.6677 16.4625 15.9363 16.1311 15.9363H8.13113C7.79976 15.9363 7.53113 15.6677 7.53113 15.3363ZM8.13113 17.748C7.79976 17.748 7.53113 18.0167 7.53113 18.348C7.53113 18.6794 7.79976 18.948 8.13113 18.948H16.1311C16.4625 18.948 16.7311 18.6794 16.7311 18.348C16.7311 18.0167 16.4625 17.748 16.1311 17.748H8.13113Z",
          fill: "#5021D1",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }